/* eslint-disable no-console */

type Type = 'ERROR' | 'LOG' | 'INFO' | 'WARN';

export class Log {
  public readonly name = 'Log';

  private readonly history: unknown[] = [];

  constructor() {
    window.onerror = (message, source, lineno, colno, error): void => {
      const errorMessage = `${(message as string) || error?.message}
            <br />&nbsp;
            at <a target="_blank" style="color: white" href="${source}:${lineno}:${colno}">${source}:${lineno}:${colno}</a>`;

      this.logMessage('ERROR', errorMessage);
    };
  }

  public error(...params: unknown[]): void {
    this.logMessage('ERROR', params);
  }

  public warn(...params: unknown[]): void {
    this.logMessage('WARN', params);
  }

  public info(...params: unknown[]): void {
    this.logMessage('INFO', params);
  }

  public log(...params: unknown[]): void {
    this.logMessage('LOG', params);
  }

  private logMessage(type: Type, params: unknown[] | string): void {
    this.history.push(params);

    // #v-ifdef !VITE_IS_PROD
    switch (type) {
      case 'INFO':
        console.info(...params);
        break;

      case 'WARN':
        console.warn(...params);
        break;
      case 'ERROR':
        console.error(...params);
        break;
      case 'LOG':
      default:
        console.log(...params);
        break;
    }
    // #v-endif
  }

  get fullSession(): unknown[] {
    return this.history;
  }
}
